module.exports = __webpack_public_path__ + "media/images/emblems/Lugano-coat_of_arms-0c3764b91ff747dce26d3149741204aa.svg";